import { entityReport } from '@toggle/toggle';

import { postEntities } from '~/api/entities/entity-service';
import { fetchSnakeMetaV2 } from '~/services/overview-widget/overview-widget-service';
import { apiFetch } from '~/utils/api-fetch/apiFetch';

export const getEntityValues = async (tag: string) => {
  const [entities, latestValues] = await Promise.all([
    postEntities({
      filter: 2,
      args: [tag],
    }),
    apiFetch(entityReport.getEntityLatestValues.path(tag), {
      schema: entityReport.getEntityLatestValues.schema,
    }),
  ]);

  if (entities.error) {
    return undefined;
  }

  const snakeMeta = await Promise.all(
    entities.data.map(e => fetchSnakeMetaV2(e.default_snake))
  ).then(req =>
    req.reduce((a, c) => {
      if (!c.error) {
        return Object.assign(a, c.data);
      }

      return a;
    }, {})
  );

  return {
    entity: entities.data[0],
    latestValues: latestValues?.error ? {} : latestValues?.data,
    snakeMeta: snakeMeta,
  };
};
